module.exports = __webpack_public_path__ + "media/phiphi/phiphi_beach-3910e7a7.jpg";